var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',[(_vm.model == 1)?[_c('vk-icon',{staticStyle:{"color":"green"},attrs:{"icon":"check"}})]:[_c('vk-icon',{staticStyle:{"color":"grey"},attrs:{"icon":"minus"}})]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }